module.exports = "/_next/static/images/liberty-5b924cc542d3bd61bcb518477aea5e41.svg";